import { wrapPageElement as pageWrapper } from './page-wrapper'
import { wrapRootElement as rootWrapper } from './root-wrapper'

export const wrapPageElement = pageWrapper
export const wrapRootElement = rootWrapper
